import React from 'react'
import { Thumbs } from '../../../@shared/elements/thumbs';

export const ProjectOwner = ({project}) => {

    const [user] = React.useState({
        user:{
            name:'The Author',
            avatar:'/assets/images/faces/default.svg',
            date:'25/07/2022',
        }
    });
  
    return (
        <div className="project-owner">
            <a href={`/users/${user?._id}`} target="_blank" rel="noreferrer" className="flex-column">
                <p>Owner</p>
                <div className="name">{user?.name}</div>
                {user?.avatar && <img src={`${user?.avatar}`} alt={user?.name} draggable="false" />}
                {!user?.avatar && <img src="/assets/images/faces/default.svg" alt={user?.name} draggable="false" />}
                <p className="date">2025-1-1</p>
            </a>
            <Thumbs
                id={0}
                likes={25}
                dislikes={3} 
            />  
        </div>
    )  
}
